import { Avatar } from '@mui/material';
import { useResource } from '@app/misc/useResource';
import { ResourceId } from '@wwf/sdk';

export const MissionTypeIconCell = ({
    iconId,
}: {
    iconId?: ResourceId | null;
}) => {
    const { data: src } = useResource(iconId);

    if (!iconId) return <>—</>;

    return (
        <Avatar
            variant="rounded"
            src={src ?? undefined}
            sx={{ width: 32, height: 32 }}
        />
    );
};
